import * as React from 'react';
import { connect } from 'react-redux';
import { useSelector, useDispatch } from 'react-redux'
import { Accordion, Card, Image } from 'react-bootstrap';
import './PolicyDetails.css';
import { useState } from 'react';
import { FNOL_SUBMIT_CLAIM, DASHBOARD, PERSONAL_INSURANCE } from '../../../routes/routes';
import KPBreadCrumb from '../../KPBreadCrumb/KPBreadCrumb';
import { showCallMeModal, showComingSoon } from '../../../actions/modalActions';
import { navigateTo } from '../../../actions/navigationActions';
import { setCoverFromPersonalInsurance, clearSelectedDamages, resetFNOL, setStep  } from '../../../actions/claimSubmitActions';
import FAQItem from '../../FAQ/FAQItem';

const PolicyDetailsWatercraft = () => {
    const profileState = useSelector(state => state.profile);
    const cover = useSelector(state => state.profile.selectedPersonalCover)
    const dispatch = useDispatch();
    const [isInEdit, updateEditing] = useState(false);
    const [accordionFAQActiveKey, setAccordionFAQActiveKey] = useState(-1);

    function addWatercraft() {
        dispatch(showCallMeModal(true));
    }

    function editPolicyInfo() {
        dispatch(showComingSoon());
    }

    function cancelEdit() {
        updateEditing(false);
    }

    function saveEdit() {
        updateEditing(false);
    }

    async function submitAClaim() {
        await dispatch(resetFNOL());
        await dispatch(clearSelectedDamages());
        await dispatch(setCoverFromPersonalInsurance(cover));
        await dispatch(setStep(1, 1));
        await dispatch(navigateTo(FNOL_SUBMIT_CLAIM));
    }

    const isMobile = window.innerWidth <= 975;
    let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }]

    let coverStartDate = (cover.riskItems[0].coverStartDate?.toString().trim().length > 0) ? cover.riskItems[0].coverStartDate : "";

    let faqSet = [{
            header: "Watercraft Details",
            body: '<div class="form-group"><div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Year</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + cover.riskItems[0].watercraftDetails.year + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Make</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + cover.riskItems[0].watercraftDetails.make + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Type</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + cover.riskItems[0].watercraftDetails.type + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Description</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + cover.riskItems[0].watercraftDetails.Description + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Brand new</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + cover.riskItems[0].watercraftDetails.brandNew + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Inspection Required</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + cover.riskItems[0].watercraftDetails.inspectionRequiredString + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Inspection received/done</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + cover.riskItems[0].watercraftDetails.inspectionDone + '</p>' +
                '</div>' +


                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Registered in South Africa</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + cover.riskItems[0].watercraftDetails.registeredLocally + '</p>' +
                '</div>',

            id: 1
        },
        {
            header: "Insurance History",
            body: '<div class="form-group"><div class="form-group row noma">' +
                '<p class="col-7 col-form-label">No. of claims in the last 2 years</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + cover.riskItems[0].numberOfClaims + '</p>' +
                '</div>' +
                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Last watercraft claim</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + (cover.riskItems[0].lastAccidentClaim !== null ? cover.riskItems[0].lastAccidentClaim : "Never had a claim") + '</p>' +
                '</div>',

        id: 2
    },];

    let faq;
    if (faqSet) {
        faq = faqSet.map((item) => {
            if (item.header !== "") {
                return <FAQItem className="mb-12px" header={item.header} body={item.body} keyId={item.id} activeKey={accordionFAQActiveKey} />
            }
        });
    }

    return (
        <>
            {isMobile &&
                <KPBreadCrumb navList={BreadcrumbDetails} activePage="Watercraft" />
            }
            <div className="box">
                <div className="pt-3 d-lg-block d-none" id="PolicyDetails">
                    <div className="pl-3 pr-3 pt-3">
                        <div id="firstDiv">
                            <div className="row mb-lg-0">
                                <div className="col-7">
                                    <h2 className="carName mb-0">{cover.riskItems[0].description}</h2>
                                </div>
                                <div className="col-5 text-right">
                                    {!isInEdit &&
                                        <button className="btn btn-outline-red mb-3" onClick={editPolicyInfo} id="EditPolicy">Edit policy</button>
                                    }
                                    {isInEdit &&
                                        <div className="">
                                            <div className="mt-3 mb-3">
                                                <button className="btn btn-outline-red mr-lg-0 mb-2" onClick={cancelEdit} id='CancelPolicyEdit'>Cancel edit</button>
                                                <button className="btn btn-outline-red mt-lg-0 mb-2 mt-2" onClick={saveEdit} id='SavePersonalEdit'>Save changes</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="row border-bottom py-2">
                                <div className="col-lg-7">
                                    <h3 className="coverAmount mb-3">{profileState.currencySymbol}{cover.riskItems[0].premium} pm</h3>
                                    {coverStartDate.length > 0 &&
                                        <div className="mb-3">
                                            <p className="font-weight-normal line-height-normal mb-0">Cover start date</p>
                                            <p className="font-size-16px font-weight-bold line-height-normal mb-0">{coverStartDate}</p>
                                        </div>
                                    }
                                </div>
                                <div className="col-lg-5 text-right">
                                    <button className="btn btn-solid-aqua" onClick={submitAClaim}>Submit a claim</button>
                                </div>
                            </div>
                            <div className="row border-bottom pt-3 pb-2">
                                <div className="col-lg-6">
                                    <p className="mb-2 Excess-amount-Title"><b>Excess amount</b></p>
                                    <p className="excessAmount mb-2">{(cover.riskItems[0] && cover.riskItems[0].excessDescription === null) ? (profileState.currencySymbol + cover.excess) : cover.riskItems[0].excessDescription}</p>
                                    <p className="insuredFor">Insured for {profileState.currencySymbol}{cover.riskItems[0].insuredForValue}</p>
                                </div>
                            </div>
                            <div className="row pt-3 pb-2">
                                <div className="col-lg-12">
                                    <p className="mb-2 Excess-amount-Title">Location detail</p>
                                    <p className="mb-2">Parked at <span className="float-right font-weight-bold">{cover.riskItems[0].address.fullAddress}</span></p>

                                </div>
                            </div>
                        </div>

                        <div id="DetailsDiv" className="mt-4">
                            <Card className="policyDetailsCodeRed  ">
                                <div className="pr-2 new-ssp-code-red-faq-block code-red-accordion-holder">
                                    <Accordion onSelect={(e) => setAccordionFAQActiveKey(Number(e))}>
                                        {faq}
                                    </Accordion>
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
                <div className="d-lg-none d-block mb-3" id="PolicyDetailsMobile" style={{ display: "none" }}>
                    <div className="pl-3 pr-3">
                        <div id="firstDivMobile" className="">
                            <div className="row mb-lg-0">
                                <div className="col-12">
                                    <h2 className="carName mb-0">{cover.riskItems[0].description}</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <h3 className="coverAmount mb-3">{profileState.currencySymbol}{cover.riskItems[0].premium} pm</h3>
                                    {coverStartDate.length > 0 &&
                                        <div className="mb-3">
                                            <p className="font-weight-normal line-height-normal mb-0">Cover start date</p>
                                            <p className="font-size-16px font-weight-bold line-height-normal mb-0">{coverStartDate}</p>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-12">
                                    {!isInEdit &&
                                        <button className="btn btn-outline-red" onClick={editPolicyInfo} id="EditPolicy">Edit policy</button>
                                    }
                                    {isInEdit &&
                                        <div className="">
                                            <div className="mt-3 mb-3">
                                                <button className="btn btn-outline-red mr-lg-0 mb-2" onClick={cancelEdit} id='CancelPolicyEdit'>Cancel edit</button>
                                                <button className="btn btn-outline-red mt-lg-0 mb-2 mt-2" onClick={saveEdit} id='SavePersonalEdit'>Save changes</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="row pb-3 border-bottom">
                                <div className="col-12">
                                    <button className="btn btn-solid-aqua" onClick={submitAClaim}>Submit a claim</button>
                                </div>
                            </div>
                            <br />
                            <div className="row border-bottom">
                                <div className="col-12">
                                    <p className="mb-0"><b>Excess amount</b></p>
                                    <p className="excessAmount">{(cover.riskItems[0] && cover.riskItems[0].excessDescription === null) ? (profileState.currencySymbol + cover.excess) : cover.riskItems[0].excessDescription}</p>
                                    <p className="insuredFor">Insured for {profileState.currencySymbol}{cover.riskItems[0].insuredForValue}</p>
                                </div>
                            </div>
                            <div className="row pt-3 pb-2">
                                <div className="col-12">
                                    <p className="mb-2 Excess-amount-Title">Location detail</p>
                                    <p className="mb-2">Parked at </p>
                                    <p className="float-md-right font-weight-bold">{cover.riskItems[0].address.fullAddress}</p>
                                </div>
                            </div>
                        </div>

                        <div id="DetailsDiv" className="mt-4">
                            <Card className="policyDetailsCodeRed  ">
                                <div className="pr-2 new-ssp-code-red-faq-block code-red-accordion-holder">
                                    <Accordion onSelect={(e) => setAccordionFAQActiveKey(Number(e))}>
                                        {faq}
                                    </Accordion>
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-2 mb-5 text-center text-lg-none float-none float-lg-right">
                <button className="btn btn-solid-green w-100" onClick={addWatercraft} >Add a watercraft</button>
            </div>
        </>
    )
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
    }
}

export default connect(mapStateToProps)(PolicyDetailsWatercraft);